import { useQueryClient } from '@tanstack/react-query';

import { queryKeys } from '@/query-keys';

export function useQueryInvalidation() {
  const queryClient = useQueryClient();

  /* Invalidate dashboard queries when accepting the recommendation from dashboard */
  const invalidateDashboardQueries = () =>
    Promise.all([
      queryClient.invalidateQueries({
        queryKey: queryKeys.dashboard.recommendations.atRiskOpenings,
      }),
      queryClient.invalidateQueries({
        queryKey: queryKeys.dashboard.recommendations.atRiskCount,
      }),
      queryClient.invalidateQueries({
        queryKey: queryKeys.dashboard.openings,
      }),
      queryClient.invalidateQueries({
        queryKey: queryKeys.dashboard.snapshot,
      }),
    ]);

  /* Invalidate openings page queries when accepting the recommendation from opening details page */
  const invalidateOpeningsPageQueries = () =>
    Promise.all([
      queryClient.invalidateQueries({
        queryKey: queryKeys.openingDetails.detail,
      }),
      queryClient.invalidateQueries({
        queryKey: queryKeys.openingDetails.channels.list,
      }),
      queryClient.invalidateQueries({
        queryKey: queryKeys.openingDetails.channels.generalRecommendation,
      }),
    ]);

  /**
   * Invalidate both dashboard and opening-details query sets. The dialog can
   * be opened from either page, and TanStack only refetches queries that are
   * currently mounted, so invalidating both is cheap and avoids brittle
   * pathname-based branching.
   */
  const invalidateRecommendationPostingQueries = () =>
    Promise.all([
      invalidateDashboardQueries(),
      invalidateOpeningsPageQueries(),
    ]);

  return { invalidateRecommendationPostingQueries };
}
